import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  OpenCourseInLabel: {
    id: 'instructor-toolbox.openCourseIn.label',
    defaultMessage: 'View course in:',
    description: 'Label for the masquerade open course in buttun',
  },
  OpenCourseInStudio: {
    id: 'instructor-toolbox.studio.label',
    defaultMessage: 'Studio',
    description: 'Label for the masquerade open course in buttun',
  },
  OpenCourseInAspects: {
    id: 'instructor-toolbox.aspects.label',
    defaultMessage: 'Aspects:',
    description: 'Label for the masquerade open course in buttun',
  },
  OpenCourseInInsights: {
    id: 'instructor-toolbox.insights.label',
    defaultMessage: 'Insights:',
    description: 'Label for the masquerade open course in buttun',
  },
  OpenCourseInBlender: {
    id: 'instructor-toolbox.blender.label',
    defaultMessage: 'Blender:',
    description: 'Label for the masquerade open course in buttun',
  },
});

export default messages;
